import { isPressureKey } from 'App/Map/CurrentValuesMap/_utils/by-domain/_utils/isPressureKey'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'

export const doAnyPointsHavePressureValues = (properties: Record<number, TProperty> | undefined) =>
  Object.values(properties ?? {}).some((property) =>
    Object.values(property.points ?? {}).some((point) => point.valuesCurrent.some(isPressureKey)),
  )
